import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Auth from "../../utils/AuthUtils";
import userAPI from "../../api/UserApi";
import { getTimeAgo } from "../../helper/Helper";

function Dashboard() {
  const { username } = Auth.getToken();

  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchLatestOrder();
  }, []);

  const fetchLatestOrder = async () => {
    try {
      const res = await userAPI.fetchLatestOrder();
      if (res.code === 200) {
        const result = res.data;

        setOrders(result);
      }
    } catch (err) {}
  };

  return (
    <>
      <div className="custom-account-dashboard">
        <div className="custom-account-header">
          <h4 className="custom-hello-text">
            Hello {username} 
          </h4>
          <p className="custom-account-desc">
            Today is a great day to check your account. You can view{" "}
            <NavLink to="/users/orders">your orders</NavLink> or explore{" "}
            <NavLink to="/shop">latest products</NavLink>.
          </p>
        </div>

        <div className="custom-account-content">
          <div className="row g-4">
            {orders ? (
              <div className="col-md-4 col-sm-6">
                <div className="custom-order-card">
                  <div className="custom-order-header">
                    Order #{orders.orderId}
                  </div>

                  <div className="custom-order-body">
                    <p>
                      <b>Date:</b> {getTimeAgo(orders?.createdAt)}
                    </p>
                    <p>
                      <b>Amount:</b> ₹{orders?.total}/-
                    </p>
                  </div>

                  <div className="custom-order-status">{orders?.status}</div>
                </div>
              </div>
            ) : (
              <div className="col-12">
                <Link to="/users/orders" className="custom-empty-card">
                  <h5>Orders</h5>
                  <p>Check your order history</p>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
